











































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { Priority } from '@/@types/LibraryComponent';
import { TaskDetailParam } from '@/@types/LibraryComponent';

@Component
export default class AccentMenu extends Vue {
  @Prop()
  private readonly taskId!: number;
  @Prop()
  public name!: string;
  @Prop()
  private tiles!: Array<Priority>;
  @Prop()
  private attribute!: string;
  @Prop({ default: false })
  private customFlag!: boolean;
  private displayName: string = '';
  @Emit('emitTaskData')
  private emitTaskData(tile: Priority): TaskDetailParam {
    this.displayName = tile.title;
    return {
      taskId: this.taskId,
      value: tile.title,
      attributeKey: this.attribute,
      customFlag: this.customFlag,
    };
  }

  private mounted() {
    this.displayName = this.name;
  }

  /**
   * タスクのプロパティから対象のオブジェクトを取得、更にそのオブジェクトのプロパティからstyleの情報を取得
   */
  private getTileStyleInfo(): {
    background: string;
    color: string;
  } | void {
    const tile = this.tiles.find((c) => c.title === this.displayName);
    if (tile) {
      return { background: tile.backgroundColor, color: tile.fontColor };
    }
  }

  private getBadgeStyleInfo(): {
    background: string;
  } | void {
    const badge = this.tiles.find((c) => c.title === this.displayName);
    if (badge) {
      return { background: badge.fontColor };
    }
  }
}
